import { render, staticRenderFns } from "./SlideUpload.vue?vue&type=template&id=2aed91d1&scoped=true"
import script from "./SlideUpload.vue?vue&type=script&lang=js"
export * from "./SlideUpload.vue?vue&type=script&lang=js"
import style0 from "./SlideUpload.vue?vue&type=style&index=0&id=2aed91d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aed91d1",
  null
  
)

export default component.exports